var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useForm } from "react-hook-form";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useCheckoutContext } from "../../../../context/useCheckoutContext";
import { useKushkiJsContext } from "../../../../context/useKushkiJsContext";
import { configCardSections } from "../../../../shared/constants/CheckoutContants";
export var useConfrontaAuth = function () {
    var form = useForm({
        defaultValues: { cityCode: "", expeditionDate: "", stateCode: "" },
    });
    var secureValidation = {
        code: "",
        message: "",
        questionnaireCode: "",
        questions: [],
    };
    var requestSecureServiceValidation = useKushkiJsContext().requestSecureServiceValidation;
    var _a = useCheckoutContext(), handlers = _a.handlers, secureOtp = _a.secureOtp, checkoutToken = _a.checkoutToken, amount = _a.amount;
    var _b = React.useState(null), selectedDate = _b[0], setSelectedDate = _b[1];
    var handleDateChange = function (date) {
        setSelectedDate(date);
        form.setValue("expeditionDate", date);
    };
    var _c = useState(99), valor = _c[0], setValor = _c[1];
    var handleCity = function (event) {
        form.setValue("cityCode", event.target.value);
    };
    var handleState = function (event) {
        form.setValue("stateCode", event.target.value);
        setValor(parseInt(event.target.value, 10));
    };
    useEffect(function () { }, [secureOtp]);
    var handleRequestOtpValidation = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var date, confrontaInfo, secureOtpRequest, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handlers.setCheckoutLoading(true);
                    date = new Date(formData.expeditionDate).toLocaleString("es-EC", {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                    });
                    confrontaInfo = {
                        confrontaBiometrics: {
                            cityCode: formData.cityCode,
                            expeditionDate: date,
                            phone: get(formData, "phone", ""),
                            stateCode: formData.stateCode,
                        },
                    };
                    secureOtpRequest = {
                        confrontaInfo: confrontaInfo,
                        secureService: get(checkoutToken, "secureService", "confrontaBiometric"),
                        secureServiceId: get(checkoutToken, "secureId", ""),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestSecureServiceValidation(secureOtpRequest)];
                case 2:
                    secureValidation = _a.sent();
                    handlers.setSecureOtp(secureValidation);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    if (e_1.code === "BIO010") {
                        handlers.setSecureOtp(__assign({}, e_1));
                        handlers.setCheckoutSection(configCardSections.confrontaQuestions);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    handlers.setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        amount: amount.total,
        form: form,
        handleCity: handleCity,
        handleDateChange: handleDateChange,
        handleRequestOtpValidation: handleRequestOtpValidation,
        handleState: handleState,
        secureValidation: secureValidation,
        selectedDate: selectedDate,
        setValor: setValor,
        valor: valor,
    };
};
